import { render, staticRenderFns } from "./DeleteGroup.vue?vue&type=template&id=54a7adc6&scoped=true&"
import script from "./DeleteGroup.vue?vue&type=script&lang=js&"
export * from "./DeleteGroup.vue?vue&type=script&lang=js&"
import style0 from "./DeleteGroup.vue?vue&type=style&index=0&id=54a7adc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a7adc6",
  null
  
)

export default component.exports